import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Divider, Stack, Typography } from "@mui/material"
import { INumericSummaryProps, NumericSummaryData } from "../constants/FinanceModels"
import { useTranslation } from "react-i18next";
import { STATE_SUMMARY_UPDATING } from "../constants/FinanceRecoil";
import { Box } from "@mui/system";

export const NumericSummary = (props: INumericSummaryProps) => {

    const { t } = useTranslation('finance');

    const [summary, setSummary] = useState<NumericSummaryData[]>(props.fields.map<NumericSummaryData>(it => ({ key: it, value: 0 })));
    const [updating, setUpdating] = useRecoilState(STATE_SUMMARY_UPDATING);

    useEffect(() => {
        if (updating) {
            let array: NumericSummaryData[] = [];

            props.query()
                .then(response => {
                    let result = response.result ? response.result : response;

                    props.fields.forEach(it => {
                        array.push({ key: it, value: result.counters[it] });
                    });

                    setSummary(array);
                })
                .finally(() => {
                    setUpdating(false);
                })
        }
    }, [updating])


    const insertBetween = (element: any, array: any) => {
        return array.flatMap((x: any) => [element, x]).slice(1);
    };


    return (
        <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" alignItems="center" columnGap={2} fontSize=".9rem">
                {insertBetween(
                    <Divider orientation="vertical" variant="middle" flexItem/>,
                    summary.map(it =>
                        <Stack direction="row" columnGap={1}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                <Typography variant="subtitle2" fontSize=".9rem" color={'primary'}>{t(`${props.i18nPath}.${it.key}`)}: <strong>{it.value}</strong></Typography>
                            </Box>
                        </Stack>
                    ))}
            </Stack>
        </Stack>
    );
}